var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVeaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#97151D;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.1,324.2l56.2,176.8h2.2l56.4-176.8h54.5L266.2,557h-63.4l-80.3-232.7H177.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362.9,557V324.2h156.8v40.6H412.1v55.5h99.5v40.6h-99.5v55.6h108.1V557H362.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M587.5,557h-52.7l80.3-232.7h63.4L758.7,557H706l-58.3-179.5h-1.8L587.5,557z M584.2,465.5h124.5v38.4H584.2 V465.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeaIcon);
export default __webpack_public_path__ + "static/media/vea_icon.d6e3810bc2642bbc5ef531a5f50f7cc6.svg";
export { ForwardRef as ReactComponent };